import * as React from 'react'
import PropTypes from 'prop-types'
import resolveAssetURL from '@/utils/resolveAssetURL'
import BlockTextScroll from '@/components/Block/TextScroll'

import {
  Container,
  BackgroundImage,
  GridContainer,
  Wrapper,
  Image,
  CircularLabelButton
} from './style'

const Verbatim = ({
  duration,
  text = '',
  background = '',
  backgroundAlt = '',
  image = '',
  imageAlt = '',
  action = null,
  display = 'regular'
}) => {
  return (
    <Container className={ `${display}` }>
      <BackgroundImage loading='lazy' src={ resolveAssetURL(background) } alt={ backgroundAlt } />
      <BlockTextScroll text={ text } duration={ duration } />
      <GridContainer>
        <Wrapper>
          <Image loading='lazy' src={ resolveAssetURL(image) } alt={ imageAlt } />
          <CircularLabelButton id="textcercle">
            { action }
          </CircularLabelButton>
        </Wrapper>
      </GridContainer>
    </Container>
  )
}

Verbatim.propTypes = {
  text: PropTypes.string,
  duration: PropTypes.string,
  background: PropTypes.string,
  backgroundAlt: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  action: PropTypes.any,
  display: PropTypes.oneOf(['regular', 'inverted'])
}

export default Verbatim
